import { NavLink, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import "./Navbar.css";

function Navbar({ wishlistCount = 0 }) {
  // 🛒 Redux cart (لو في منتجات من السلة بتاعة Redux)
  const cartItems = useSelector((state) => state.cart.items);

  // 🛒 حالة إضافية علشان نتابع الكارت من localStorage
  const [localCartCount, setLocalCartCount] = useState(0);

  // ✅ حساب عدد العناصر من Redux
  const reduxCartCount = cartItems.reduce(
    (total, item) => total + item.quantity,
    0
  );

  // ✅ متابعة localStorage cart
  useEffect(() => {
    const updateCartFromLocalStorage = () => {
      const cart = JSON.parse(localStorage.getItem("cart")) || [];
      const total = cart.reduce((sum, item) => sum + (item.quantity || 1), 0);
      setLocalCartCount(total);
    };

    updateCartFromLocalStorage();

    // 🔄 تحديث عند أي تغيير في localStorage (من TopProducts أو غيرها)
    window.addEventListener("storage", updateCartFromLocalStorage);

    return () =>
      window.removeEventListener("storage", updateCartFromLocalStorage);
  }, []);

  // ✅ ندمج العدّين (Redux + LocalStorage)
  const totalCartCount = reduxCartCount + localCartCount;

  return (
    <nav className="navbar navbar-expand-lg shadow-sm py-3 px-4 custom-navbar sticky-top">
      <div className="container-fluid">
        {/* Logo */}
        <NavLink className="navbar-brand fw-bold fs-3 text-uppercase" to="/">
          <span className="brand-highlight">E</span> Commerce
        </NavLink>

        {/* Toggle button (mobile) */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="fas fa-bars toggler-fa"></i>
        </button>

        {/* Links + Icons */}
        <div className="collapse navbar-collapse" id="navbarNav">
          {/* Pages Links */}
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-3">
            <li className="nav-item">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/about"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/products"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Products
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/testimonials"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Testimonials
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  isActive ? "nav-link active" : "nav-link"
                }
              >
                Contact
              </NavLink>
            </li>
          </ul>

          {/* Icons */}
          <div className="d-flex align-items-center gap-4 navbar-icons">

            <Link to="/login" className="nav-icon">
              <i className="fas fa-user fa-lg"></i>
            </Link>

            {/* ❤️ Wishlist */}
            <Link to="/wishlist" className="position-relative nav-icon">
              <i className="fas fa-heart fa-lg"></i>
              {wishlistCount > 0 && (
                <span
                  className="wishlist-badge position-absolute top-0 start-100 translate-middle badge rounded-circle bg-danger text-white"
                  style={{
                    fontSize: "0.7rem",
                    padding: "0.35em 0.55em",
                    transform: "translate(-40%, 25%)",
                  }}
                >
                  {wishlistCount}
                </span>
              )}
            </Link>

            {/* 🛒 Cart */}
            <Link to="/cart" className="position-relative nav-icon">
              <i className="fas fa-shopping-cart fa-lg"></i>
              {totalCartCount > 0 && (
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-danger text-white"
                  style={{
                    fontSize: "0.7rem",
                    padding: "0.35em 0.55em",
                    transform: "translate(-40%, 25%)",
                  }}
                >
                  {totalCartCount}
                </span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
